export default {

  namespaced: true,

  state: () => ({
    account_id: null,

    salesman: {
      id: null,
      name: 'Vendedor não identificado'
    },

    baseOrder: {
      operation_id: 1,

      unidentified_client: 1,

      order_conditional_id: null,

      client_id: null,
      client_name: 'Consumidor Final',

      salesman_id: null,
      salesman_name: null,

      order_products: [],

      order_bills: [],

      addition: 0,
      discount: 0,
      shipping: 0,

      notes: null,

      account_id: null,

      orderStatus: 'order'
    },

    order: {
      operation_id: 1,

      unidentified_client: 1,

      order_conditional_id: null,

      client_id: null,
      client_name: 'Consumidor Final',

      salesman_id: null,
      salesman_name: null,

      order_products: [],

      order_bills: [],

      addition: 0,
      discount: 0,
      shipping: 0,

      notes: null,


      orderStatus: 'order'
    },

    id: null,

    saveAs: "order",

    error: null,

    lastStoredOrder: {},


  }),

  getters: {
    productsTotal: state => {
      return (
        Math.round(
          state.order.order_products.reduce(
            (total, row) => total + parseFloat(row.quantity * row.price),
            0
          ) * 100
        ) / 100
      );
    },

    productsTotalOnTerms: state => {
      return (
        Math.round(
          state.order.order_products.reduce(
            (total, row) => total + parseFloat(row.quantity * row.company_price_payment_on_terms),
            0
          ) * 100
        ) / 100
      );
    },

    productsTotalImmediate: state => {
      return (
        Math.round(
          state.order.order_products.reduce(
            (total, row) => total + parseFloat(row.quantity * row.company_price_payment_immediate),
            0
          ) * 100
        ) / 100
      );
    },

    netTotal: state => {
      return (
        Math.round(
          (state.order.order_products.reduce(
            (total, row) => total + parseFloat(row.quantity * row.price),
            0
          ) -
            state.order.discount + state.order.addition + state.order.shipping) *
          100
        ) / 100
      );
    },

    netTotalOnTerms: state => {
      return (
        Math.round(
          (state.order.order_products.reduce(
            (total, row) => total + parseFloat(row.quantity * row.company_price_payment_on_terms),
            0
          ) -
            state.order.discount + state.order.addition + state.order.shipping) *
          100
        ) / 100
      );
    },

    netTotalImmediate: state => {
      return (
        Math.round(
          (state.order.order_products.reduce(
            (total, row) => total + parseFloat(row.quantity * row.company_price_payment_immediate),
            0
          ) -
            state.order.discount + state.order.addition + state.order.shipping) *
          100
        ) / 100
      );
    },

    orderBillsTotal: state => {
      return (
        Math.round(
          state.order.order_bills.reduce(
            (total, row) => total + parseFloat(row.value),
            0
          ) * 100
        ) / 100
      );
    },

    hasPriceOnTerms(state, getters, rootState) {
      return (rootState.auth.user.company.product_payment_policy == 2)
    },

    paymentsOnTerms(state, getters, rootState) {
      //return rootState.auth.user.company.order_apply_price_payment_on_terms_payment_method_2
      let paymentsOnTerms = []

      if (rootState.auth.user.company.order_apply_price_payment_on_terms_payment_method_2 == 1) {
        paymentsOnTerms.push(2)
      }

      if (rootState.auth.user.company.order_apply_price_payment_on_terms_payment_method_3 == 1) {
        paymentsOnTerms.push(3)
      }

      if (rootState.auth.user.company.order_apply_price_payment_on_terms_payment_method_4 == 1) {
        paymentsOnTerms.push(4)
      }

      if (rootState.auth.user.company.order_apply_price_payment_on_terms_payment_method_5 == 1) {
        paymentsOnTerms.push(5)
      }

      if (rootState.auth.user.company.order_apply_price_payment_on_terms_payment_method_15 == 1) {
        paymentsOnTerms.push(15)
      }

      return paymentsOnTerms

    },

    hasPaymentOnTerms(state, getters, rootState) {
      let orderBillsOnTerms = state.order.order_bills.filter((row) => {
        return getters.paymentsOnTerms.includes(row.payment_method)
      })

      return (orderBillsOnTerms.length > 0)
    },
    customer(state) {
      return state.order.client_name
    },
    salesman(state) {
      return state.salesman
    },
    getOperation(state) {
      return state.order.operation_id
    }

  },

  mutations: {
    setOrder(state, data) {
      this.commit("orderForm/setClient", data.person);

      this.commit("orderForm/setSalesman", data.salesman);

      this.commit("orderForm/setOrderProducts", data.orderProducts);

      this.commit("orderForm/setOrderBills", data.orderBills);

      state.id = data.order.id;

      state.order.number = data.order.number;
      state.order.addition = data.order.addition;
      state.order.discount = data.order.discount;
      state.order.shipping = data.order.shipping;
    },

    setConditional(state, data) {

      this.commit("orderForm/setClient", data.person);

      this.commit("orderForm/setSalesman", data.salesman);

      this.commit("orderForm/setOrderProducts", data.conditionalProducts);

      state.order.order_conditional_id = data.conditional.id;
    },

    // setOperation(state, data) {
    //   state.operation = data;
    // },

    setOrderProducts(state, orderProducts) {
      state.order.order_products = orderProducts;
    },

    setOrderBills(state, orderBills) {
      state.order.order_bills = orderBills;
    },

    setClient(state, client) {
      if (client == null || !client.id) {
        this.commit("orderForm/removeClient");
        return;
      }

      state.order.unidentified_client = 0;
      state.order.client_id = client.id;
      state.order.client_name = client.name;
    },

    removeClient(state) {
      state.order.unidentified_client = 1;
      state.order.client_id = null;
      state.order.client_name = 'Consumidor Final'

    },

    setSalesman(state, salesman) {
      // if (!salesman) {
      //   this.commit("orderForm/removeSalesman");
      //   return;
      // }

      state.salesman.id = salesman.id;
      state.salesman.name = salesman.name;
    },

    removeSalesman(state) {
      state.salesman.id = null;
      state.salesman.name = 'Vendedor não identificado';

    },
    getSalesman(state) {
      state.order.salesman_id = state.salesman.id;
      state.order.salesman_name = state.salesman.name;
    },

    addProduct(state, { product, quantity }) {
      
      let orderProduct = {
        product_base_id: product.id,
        description: product.description,
        price: product.product_variant[0].product_company[0].company_price,
        company_price_payment_on_terms: product.product_variant[0].product_company[0].company_price_payment_on_terms,
        company_price_payment_immediate: product.product_variant[0].product_company[0].company_price_payment_immediate,
        quantity: quantity,
        cost: product.product_variant[0].cost
      };

      state.order.order_products.push(orderProduct);
    },

    increaseProduct(state, { product, quantity }) {
      let productIndex = state.order.order_products
        .map(row => row.product_base_id)
        .indexOf(product.id);

      if (productIndex >= 0) {
        state.order.order_products[productIndex].quantity = parseFloat(state.order.order_products[productIndex].quantity) + parseFloat(quantity)
      } else {
        this.commit("orderForm/addProduct", { product: product, quantity: quantity });
      }
    },

    decreaseProduct(state, product) {
      let productIndex = state.order.order_products
        .map(row => row.product_base_id)
        .indexOf(product.id);

      if (productIndex < 0) {
        return;
      }
      if (state.order.order_products[productIndex].quantity > 1) {
        state.order.order_products[productIndex].quantity--;
      } else {
        this.commit("orderForm/removeProduct", product);
      }
    },

    removeProduct(state, product) {
      let productIndex = state.order.order_products
        .map(row => row.product_base_id)
        .indexOf(product.id);

      state.order.order_products.splice(productIndex, 1);
    },

    removeLastProduct(state) {
      myarray[myarray.length - 1];
      // let productIndex = state.order.order_products
      //   .map(row => row.product_base_id)
      //   .indexOf(product.id);

      state.order.order_products.splice(state.order.order_products.length - 1, 1);
    },

    setOrderBills(state, order_bills) {
      state.order.order_bills = order_bills;
    },

    setAccountId(state, account_id) {
      state.account_id = account_id;
    },

    updateProduct(state, { product, index }) {
      let newArr = JSON.parse(JSON.stringify(state.order.order_products));

      newArr[index] = product;

      //Vue.set(state.order.order_products, index, product);
      state.order.order_products = newArr;
    },

    addDiscount(state, discount) {
      state.order.discount = discount;
    },

    addAddition(state, addition) {
      state.order.addition = addition;
    },

    addShipping(state, shipping) {
      state.order.shipping = shipping;
    },

    removeDiscount(state) {
      state.order.discount = 0;
    },

    removeShipping(state) {
      state.order.shipping = 0;
    },

    removeAddition(state) {
      state.order.addition = 0;
    },

    orderStored(state, response) {
      state.lastStoredOrder = response;
    },

    reset(state) {
      state.id = null
      state.order = JSON.parse(JSON.stringify(state.baseOrder));
    },

    setError(state, error) {
      state.error = error
    }

  },

  actions: {
    async getOrder({ commit }, id) {
      const data = await this.dispatch("order/showOrder", id);

      commit("setOrder", data);
    },

    async getConditional({ commit }, id) {
      const data = await this.dispatch("conditional/showConditional", id);

      commit("setConditional", data);
    },

    storeOrder({ commit, state, getters }, saveAs) {
      commit("getSalesman");

      // console.log(state.order);

      // const data = await axios.post('/erp/order/order', params);
      // return data;

      if (getters.hasPriceOnTerms) {
        let orderProducts = JSON.parse(JSON.stringify(state.order.order_products));

        orderProducts = orderProducts.map((row) => {
          row.price = (getters.hasPaymentOnTerms) ? row.company_price_payment_on_terms : row.company_price_payment_immediate
          return row
        })

        commit("setOrderProducts", orderProducts);
      }

      let url = "/erp/order/order";

      if (state.id) {
        url = url + "/" + state.id;
      }

      return new Promise((resolve, reject) => {
        axios
          .post(url, state.order)
          .then(response => {
            this.commit("orderForm/orderStored", response);
            this.dispatch('orderForm/emitOrderBill')
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    storeConditional({ commit, state }, saveAs) {
      let url = "conditional/emit-conditional";

      return new Promise((resolve, reject) => {
        this.$axios
          .$post(url, state.order)
          .then(response => {
            //commit("orderStored");
            resolve(response);
          })
          .catch(error => {
            commit("app/setRequestError", error, { root: true });
            reject(error);
          });
      });
    },
    emitOrderBill({ commit, state }) {
      axios
        .post(`${process.env.BASE_URL}api/emitorderbill/store`, {
          'order_id': state.lastStoredOrder.data.id,
          'account': state.account_id,
        })
        .then(response => { })
        .catch(error => { });
    }
  }
}